<template>
  <div>
    <AnimatedBackground/>
    <div id="loan-application-success-page" class="viewport viewport-with-top-nav viewport-compact">
      <div class="d-flex small justify-content-center align-content-center mb-3">
        <div class="checkmark-container mt-lg-5">
          <div class="checkmark draw"></div>
        </div>
      </div>
      <div class="fade-in-up animation-delay" style="--delay-index:1;">
        <div id="success-message" class="h5 text-center my-4" v-html="$t('LoanApplicationThankYouPage.title')"/>
      </div>

      <div class="flex-grow-1 d-lg-none"></div>

      <button class="btn btn-block btn-lg btn-primary"
              id="button-close"
              data-dismiss="modal"
              :aria-label="$t('LoanApplicationThankYouPage.close')"
              @click="goToCustomerOverviewPage()">
        {{ $t('LoanApplicationThankYouPage.close') }}
      </button>
      <div class="flex-grow-1 d-none d-lg-flex"></div>
    </div>
  </div>
</template>

<script>
import AnimatedBackground from '@shared/components/AnimatedBackground'

export default {
  name: 'LoanApplicationThankYouPage',
  components: { AnimatedBackground },
  methods: {
    goToCustomerOverviewPage() {
      this.$router.replace({ name: 'no-back', params: { page: 'customer-overview' } })
    }
  }
}
</script>
